export const getVariants = (ai_key: string) => [
  {
    label: 'Submissive',
    imageSrc: `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/${ai_key}/Submissive.png`,
  },
  {
    label: 'Neutral',
    imageSrc: `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/${ai_key}/Neutral.png`,
  },
  {
    label: 'Flirty',
    imageSrc: `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/${ai_key}/Flirty.png`,
  },
  {
    label: 'Naughty',
    imageSrc: `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/${ai_key}/Naughty.png`,
  },
  {
    label: 'Dominant',
    imageSrc: `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/${ai_key}/Dominant.png`,
  },
];
